import { PawIcon } from './PawIcon';

/**
 * author: Simran
 * id 802EBFA2-6D86-4E93-BEBF-7F69F6C98C01
 * name paw
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/paw.svg
 * tags
 * - Animal 
 * - Nature 
 */
export const PetsIcon = PawIcon;
export default PetsIcon